module.exports = {
	"basic": {
		"title": "Basic axis",
		"description": "Basic axis example.",
		"tags": [
			"Axis"
		]
	},
	"timezone": {
		"title": "Timezones",
		"description": "Time axis with timezone support.",
		"tags": [
			"TimeAxis",
			"Timezones"
		]
	},
	"duration": {
		"title": "Durations",
		"description": "Time axis that shows elapsed time, rather than absolute dates.",
		"tags": [
			"TimeAxis",
			"Duration"
		]
	},
	"format": {
		"title": "TimeAxis Formats",
		"description": "Time Axis with different format types",
		"tags": [
			"TimeAxis"
		]
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/website/examples/examples.json
// module id = 297
// module chunks = 0